var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDataroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.7414V22.4081H9.125V12.7414C9.12638 11.5555 10.0769 10.5947 11.25 10.5933H19.3098C19.8738 10.5918 20.4149 10.8183 20.8125 11.2226L24.4402 14.8896H36.75C37.9231 14.891 38.8736 15.8518 38.875 17.0377V25.6303H36.75V17.0377H23.5598L19.3098 12.7414H11.25Z",
    fill: "#4776E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3125 24.5567V28.853H9.125C7.95359 28.853 7 29.8165 7 31.0012V37.4451C7 38.6293 7.95359 39.5932 9.125 39.5932H14.4375V24.5567H12.3125ZM9.125 31.0007H12.3125V37.4451H9.125V31.0007Z",
    fill: "#4776E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 31.0007V28.8525H29.3125V26.7044H27.1875V28.8525H25.0625V31.0007H27.1875V37.4451C27.1875 38.6293 28.1411 39.5933 29.3125 39.5933H32.5V37.4451H29.3125V31.0007H32.5Z",
    fill: "#4776E6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41 31.0007C41 29.816 40.0464 28.8525 38.875 28.8525H34.625V31.0007H38.875V33.1488H35.6875C34.5139 33.1488 33.5625 34.1105 33.5625 35.297V37.4451C33.5625 38.6315 34.5139 39.5933 35.6875 39.5933H41V31.0007ZM38.875 37.4451H35.6875V35.297H38.875V37.4451Z",
    fill: "#4776E6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.625 28.8525H21.875C23.0464 28.8525 24 29.816 24 31.0007V39.5933H18.6875C17.5139 39.5933 16.5625 38.6315 16.5625 37.4451V35.297C16.5625 34.1105 17.5139 33.1488 18.6875 33.1488H21.875V31.0007H17.625V28.8525ZM18.6875 37.4451H21.875V35.297H18.6875V37.4451Z",
    fill: "#4776E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDataroom);
export default __webpack_public_path__ + "static/media/ic-dataroom.3d9264de30796e51f3539f5116da0c44.svg";
export { ForwardRef as ReactComponent };